export enum Roles {
  administrator = "administrator",
  agency = "agency",
  auditor = "auditor",
  operator = "operator",
  agency_v2 = "agency_v2",
  biUser = "bi-user",
  cpoDeferralEditor = "deferral-editor",
  cpoFileSubmitter = "cpo-file-submitter",
  cpoFileSubmissionViewer = "cpo-file-submission-viewer",
  cpoDailyProductionValuesEditor = "daily-production-values-editor",
  anpgManagement = "anpg-management"
}
